/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const REDUCE_TICKET_HOLD = gql`
  mutation ReduceTicketHold($ticketOrderId: ID!, $lines: [TicketLineInput!]!) {
    reduceTicketHold(ticketOrderId: $ticketOrderId, lines: $lines) {
      ticketOrderId
      status
      releaseReason
      ticketAmount
      convenienceFee
      total
      holdExpiresAt
      lines {
        tierId
        tierName
        quantity
        unitPrice
        lineTotal
        feePerTicket
        lineFee
      }
    }
  }
`;
